import { RootState } from 'store/root-reducer';

export const hqUserSummarySelector = ({ hqUser }: RootState) => hqUser.summary;
